// CON-1999: a group share-code apply skips steps the group already has (same
// name and timing). The success message names them, so a re-apply that added
// nothing does not read as if it updated those steps.
function shareCodeAppliedMessage(skippedSteps = []) {
  if (!Array.isArray(skippedSteps) || skippedSteps.length === 0) {
    return 'Successfully Applied the Share Code';
  }
  const count = skippedSteps.length;
  const noun = count === 1 ? 'step' : 'steps';
  return `Share Code applied. We skipped ${count} ${noun} this group already has: ${skippedSteps.join(', ')}`;
}

export default shareCodeAppliedMessage;
